import { Button, Form, message, Modal, notification } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import ExpenseForm from "./expense-form";
import useExpenses from "hooks/useExpenses";
const NewDipenseModal = () => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { isModalOpen, modalType } = useSelector(
        (state) => state.modals
    );
    const { addExpense, expense, setExpense, isLoading, error, setError } = useExpenses();
    // , getAllExpenses, expense, setExpense, expenses, setExpenses, isLoading, error, setError
    const [isSendForAdd, setIsSendForAdd] = useState(false);
    useEffect(() => {
        if (isSendForAdd) {
            if (error) {
                message.error(
                    t("expenses.crud.form.error.add") + " " + error
                )
            } else {
                message.success(
                    t("expenses.crud.form.add.success")
                )
                onClose();
            }
            setIsSendForAdd(false);
        }
    }, [isSendForAdd, error]);
    const open = isModalOpen && modalType === "new_dipense";

    const onSubmit = async (values) => {
        setError(null);
        setIsSendForAdd(false);
        try {
            await addExpense(values);
        } catch (error) {
            notification.error({
                message: t("expenses.crud.form.errorAdd.add"),
                description: error,
                role: "alert",
                duration: 3,
            });
        } finally {
            setIsSendForAdd(true);
        }
    };

    const onClose = () => {
        form.resetFields();
        dispatch(closeModal());
    };
    return (
        <Modal
            title={
                <h4 style={{ textAlign: "center" }}>{t("expenses.crud.form")}</h4>
            }
            open={open}
            onCancel={onClose}
            destroyOnClose
            footer={[
                <Button key="cancel" onClick={onClose} className="custom-btn-1">
                    {t("expenses.crud.form.button.cancel")}
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    htmlType="submit"
                    form="expense_form"
                    disabled={isLoading}
                    className="custom-btn-2"
                >
                    {t("expenses.crud.form.button.add")}
                </Button>,
            ]}
            centered={true} 
            styles={{ content: { overflowY: "auto", maxHeight: "75vh" } }}
        >
            <ExpenseForm form={form} onSubmit={onSubmit} />
        </Modal>
    );
};

export default NewDipenseModal;
